import React, { FC, useMemo } from 'react';

import { LoyaltyRewardsEmptyScreen } from './empty-screen/loyalty-rewards-empty-screen';
import { LoyaltyRewardsCategory } from './loyalty-rewards-category';
import { ILoyaltyRewardsList, NonNullableRewardCategory } from './types';

export const LoyaltyRewardsList: FC<ILoyaltyRewardsList> = ({
  handleOnPress,
  rewardCategories,
  engineRewardsMap,
  rewardsEvaluationMap,
  sanityRewardsMap,
}) => {
  // Find first unavailable category to display progress meter
  const firstUnavailableCategory = rewardCategories.find((category: NonNullableRewardCategory) => {
    if (!category.rewards?.length || !category.label?.en) {
      return false;
    }
    const engineRewardItem = engineRewardsMap[category?.rewards[0]?.loyaltyEngineId || ''];
    if (engineRewardItem.locked) {
      return true;
    }
    return false;
  });

  const renderedCategories = useMemo(
    () =>
      rewardCategories.map((category: NonNullableRewardCategory) => {
        // Skip empty categories (without rewards or label)
        if (!category.rewards?.length || !category.label?.en) {
          return null;
        }

        return (
          <LoyaltyRewardsCategory
            key={category.label.en}
            category={category}
            firstUnavailableCategory={firstUnavailableCategory}
            rewardsEvaluationMap={rewardsEvaluationMap}
            sanityRewardsMap={sanityRewardsMap}
            engineRewardsMap={engineRewardsMap}
            handleOnPress={handleOnPress}
          />
        );
      }),
    [
      engineRewardsMap,
      firstUnavailableCategory,
      handleOnPress,
      rewardCategories,
      rewardsEvaluationMap,
      sanityRewardsMap,
    ]
  );

  if (renderedCategories.every(category => !category)) {
    return <LoyaltyRewardsEmptyScreen />;
  }

  return renderedCategories;
};
